// ABOUTME: Tab configuration for the warehouse outbound shipments page
// ABOUTME: Holds the shipments grid and the claims filed on those shipments

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

export const warehouseOutboundShipmentsConfig = (claimCounts) => {
    return {
        shipments: {
            title: 'shipments',
            icon: <LocalShippingIcon/>,
            isSingleDataGrid: true,
        },
        claims: {
            title: 'claims',
            icon: <ReportProblemOutlinedIcon/>,
            isSingleDataGrid: true,
            // The badge counts claims waiting on the fulfilment to release the shipper's reply.
            ...(claimCounts && { count: claimCounts.replied }),
        },
    };
};
